<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-3">
                                        <b-form-input
                                            v-model="filter"
                                            class="form-control"
                                            type="search"
                                            :placeholder="$t('label.search')"
                                            v-on:change="searchListing"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="col-md-6"></div>
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <b-button
                                            variant="danger"
                                            class="mr-2"
                                            :disabled="!status.save"
                                            :title="$t('label.export') + ' ' + $t('label.pdf')"
                                            v-b-tooltip.hover
                                            @click="requestExportPdf"
                                        >
                                            <i class="mdi mdi-file-pdf-box"></i>
                                        </b-button>
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            menu-class="dropdown-menu-250"
                                            class="mr-2"
                                            right
                                            v-b-tooltip.hover
                                            :title="$t('label.filter')"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.location') }}
                                                </label>
                                                <multiselect
                                                    v-model="locationFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="locationDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.status') }}
                                                </label>
                                                <multiselect
                                                    v-model="isActive"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="statusDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                        </b-dropdown>
                                        <b-button
                                            variant="info"
                                            v-on:click="openForm"
                                            v-b-tooltip.hover
                                            :title="$t('label.createX', [])"
                                        >
                                            <i class="mdi mdi-plus"></i>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                                hover
                                small
                            >
                                <template #cell(location)="data">
                                    <span>{{ data.item.location ? data.item.location.name : '' }}</span>
                                </template>
                                <template #cell(status)="data">
                                    <b-badge
                                        :variant="tableRows[data.index].isActive ? 'success' : 'secondary'"
                                    >
                                        {{ tableRows[data.index].isActive ? $t('label.active') : $t('label.inactive') }}
                                    </b-badge>
                                </template>
                                <template #cell(actions)="data">
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info"
                                        v-b-tooltip.hover="{ boundary: 'window' }"
                                        :title="$t('label.updateX', [])"
                                        @click.stop="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-pencil font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-danger ml-1"
                                        v-b-tooltip.hover="{ boundary: 'window' }"
                                        :title="data.item.isActive==0?$t('label.restoreX', []):$t('label.deleteX', [])"
                                        v-on:click="deleteConfirmation(data.item)"
                                    >
                                        <i :class="[`mdi font-size-18 mdi-delete-${data.item.isActive==0?'restore':'outline'}`]"></i>
                                    </a>
                                    <i
                                        v-b-tooltip.hover="{ boundary: 'window' }"
                                        :title="$t(data.detailsShowing ? 'label.hideX' : 'label.viewX', [$t('module.group')])"
                                        :class="['ml-1 cursor-pointer text-info font-size-18', data.detailsShowing ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down']"
                                        @click.stop="data.toggleDetails()"
                                    ></i>
                                </template>
                                <template #row-details="row">
                                    <PhoneExtGroupSortable :phoneExtUUID="row.item.uuid" />
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                        <div v-if="totalPage" class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
                            <small class="text-muted">{{ $t('label.total') }}: {{ totalPage }}</small>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalPage"
                                :per-page="perPage"
                                v-on:change="pageNavigation"
                                variant="info"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="phone-ext-form"
            :title="$t(phoneExt.uuid ? 'label.updateX' : 'label.createX', [$t('module.phoneExtension')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            centered
        >
            <b-container fluid>
                <PhoneExtForm
                    :phoneExtUUID="phoneExt.uuid"
                    :searchCriteria="searchCriteria"
                    @done="closeForm"
                    ref="phoneExtForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="phone-ext-delete"
            :title="phoneExt.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', [])"
            @hidden="closeForm"
            hide-header-close
        >
            <p class="my-4">{{ phoneExt.isActive==0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" class="col-2" @click="$bvModal.hide('phone-ext-delete')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2 col-2"
                    v-on:click="requestDelete"
                    :disabled="!status.save"
                >
                    {{ phoneExt.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import i18n from "@/i18n";
import { SESSION, SHARED } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { phoneExtMethods, lookupMethods } from "@/state/api";
import { PHONE_EXT_MODULE } from "@/state/api/phoneExt.state";
import PhoneExtGroupSortable from "@/views/pages/admin/phoneExtension/phoneExtentionGroup/phoneExtGroupSortable";
import PhoneExtForm from "@/views/pages/admin/phoneExtension/phoneExtForm";

export default {
    components: { Multiselect, PhoneExtForm, PhoneExtGroupSortable },
    async created() {
        await this.lookupLocation({});
        sessionHelper.clearSearch(SESSION.PHONE_EXT_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();
    },
    data() {
        return {
            filter: "",
            searchCriteria: {},
            locationFilter: null,
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            fields: [
                { key: 'name', label: i18n.t("label.name"), sortable: true, class: 'text-nowrap' },
                { key: 'location', label: i18n.t("module.location"), sortable: true, class: 'text-nowrap' },
                { key: 'date', label: i18n.t("label.date"), sortable: true, class: 'text-nowrap' },
                { key: 'status', label: i18n.t("label.status"), sortable: false, class: 'text-nowrap' },
                { key: 'actions', label: i18n.t("label.action"), sortable: false, class: 'text-nowrap' },
            ],
            phoneExt: {
                uuid: "",
                isActive: false,
            },
        };
    },
    methods: {
        ...phoneExtMethods,
        ...lookupMethods,
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.PHONE_EXT_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PHONE_EXT_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: this.isActive.value,
                    locationUuid: null,
                    searchValue: "",
                    searchArray: [],
                };
            }
            this.getPhoneExtList(this.searchCriteria);
        },
        requestExportPdf() {
            if (!this.status.save) return;
            return this.exportPhoneExtPdf({data: {}})
                .then((result) => {
                    if (result instanceof Blob) {
                        const url = URL.createObjectURL(result);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = 'phone-extensions.pdf';
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        setTimeout(() => URL.revokeObjectURL(url), 1000);
                    }
                });
        },
        getPhoneExtList(filter) {
            this.getAllPhoneExt({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.PHONE_EXT_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            this.currentPage = pageNumber;
            let filter = sessionHelper.retrieveSearch(SESSION.PHONE_EXT_SEARCH);
            filter.pageNumber = pageNumber;
            this.getPhoneExtList(filter);
        },
        searchListing() {
            this.currentPage = 1;
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            this.searchCriteria.isActive = this.isActive.value;
            this.searchCriteria.locationUuid = this.locationFilter?.value == 1 ? null : this.locationFilter?.value;
            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getPhoneExtList(this.searchCriteria);
        },
        deleteConfirmation(data) {
            this.phoneExt = {
                uuid: data.uuid,
                isActive: data.isActive,
            };
            this.$bvModal.show('phone-ext-delete');
        },
        requestDelete() {
            if (!this.status.save) return;
            let data = {
                uuid: this.phoneExt.uuid,
                isActive: this.phoneExt.isActive == 0 ? 1 : 0,
            };
            return this.updatePhoneExtStatus({data, filter: this.searchCriteria})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) this.$bvModal.hide('phone-ext-delete');
                }));
        },
        openForm(data) {
            if (data?.uuid) {
                this.phoneExt = {
                    uuid: data.uuid,
                    isActive: data.isActive,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('phone-ext-form');
            });
        },
        closeForm() {
            this.phoneExt = {
                uuid: "",
                isActive: false,
            };
            this.$bvModal.hide('phone-ext-form');
        },
    },
    computed: {
        locationDdl() {
            return [
                { value: 1, text: i18n.t('label.all') },
                ...this.$store.state.api.lookup.locationDdl,
            ];
        },
        ...mapState(PHONE_EXT_MODULE, ['status']),
        tableRows() {
            return (this.$store.state.api.phoneExt.list.data || []).map(item => ({...item}));
        },
        totalPage() {
            return this.$store.state.api.phoneExt.list.pagination.total || 0;
        },
    },
}
</script>
